module.exports = __webpack_public_path__ + "static/media/galerija_2013 (12).cc97ff75.jpg";